var axios = require('axios')
/**
 * @Params : filter + search
 * @Method : get
 */
axios.getOutletList = function (params, cancel, success, callBackError) {
  this.get(process.env.prefix_outlet + '/outlets/' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getPostOutletList = function (params, cancel, success, callBackError) {
  this.post(process.env.prefix_outlet + '/list-outlets/', params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
/**
 * @Params : uuid
 * @Data : field active
 * @Method : put
 */
axios.updateStatusOutlet = function (params, data, success, callBackError) {
  this.put(process.env.prefix_outlet + '/outlets/update-status/' + params, data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
/**
 * @Params : uuid
 * @Method : get
 */
axios.getOutletDetail = function (params, success, callBackError) {
  this.get(process.env.prefix_outlet + '/outlets/' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
/**
 * Get file tradezone of the store
 * @Params : uuid
 * @Method : get
 */
 axios.exportTradezone = function (params, success, callBackError) {
  this.get(process.env.prefix_outlet + '/outlet/get-file-tradezone/' + params).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url
    link.setAttribute('download', `Tradezone-store-${params}.kml`);
    document.body.appendChild(link);
    link.click();
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
/**
 * @Params : outletID
 * @Method : get
 */
axios.getOpenHours = function (params, success, callBackError) {
  this.get(process.env.prefix_outlet + '/openhours/' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
/**
 * @Params : uuid
 * @Data : item
 * @Method : put
 */
axios.updateOutletDetail = function (params, data, success, callBackError) {
  this.put(process.env.prefix_outlet + '/outlets/' + params, data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
/**
 * @Data : open hours
 * @Method : post
 */
axios.updateOpenHours = function (data, success, callBackError) {
  this.post(process.env.prefix_outlet + '/openhours', data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
axios.publishCombo = function (data, success, callBackError) {
  this.post(process.env.prefix_menu + '/combos/publish', data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.publishMenu = function (data, success, callBackError) {
  this.post(process.env.prefix_menu + '/menu-publish', data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
/**
 * @Data : item
 * @Method : post
 */
axios.createOutlet = function (data, success, callBackError) {
  this.post(process.env.prefix_outlet + '/outlets', data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
/**
 * @Data : open hours
 * @Method : post
 */
axios.createOpenHours = function (data, success, callBackError) {
  this.post(process.env.prefix_outlet + '/openhours', data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
/**
 * @Params : uuid
 * @Data : field active
 * @Method : put
 */
axios.updateStatusStoreGroup = function (params, success, callBackError) {
  let uuid = params['uuid']
  delete params['uuid']
  let active = params
  this.put(process.env.prefix_outlet + '/outlet-groups/' + uuid, active).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
/**
 * Get store group list
 * @Data: params
 * @Method: GET
 */
axios.getStoreGroupList = function (params, success, callBackError) {
  this.get(process.env.prefix_outlet + '/outlet-groups' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
 * Create store group list
 * @Data: params
 * @Method: POST
 */
axios.createStoreGroup = function (data, success, callBackError) {
  this.post(process.env.prefix_outlet + '/outlet-groups', data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
 * Get store group detail
 * @data: params
 * @method: GET
 */
axios.getStoreGroupDetail = function (params, success, callBackError) {
  this.get(process.env.prefix_outlet + '/outlet-groups/' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
 * Update store group
 * @data: params
 * @method: GET
 */
axios.updateStoreGroupDetail = function (params, data, success, callBackError) {
  this.put(process.env.prefix_outlet + '/outlet-groups/' + params, data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
* Get store list
* @data: params
 * @method: GET
*
 * */
axios.getStoreListUnlimit = function (params, success, callBackError) {
  this.get(process.env.prefix_outlet_fe + '/outlets/list/' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getStoreListFullDetails = function (success, callBackError) {
  this.get(process.env.prefix_outlet_fe + '/outlets?limit=99999').then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getStoreCouponList = function (params, cancel, success, callBackError) {
  this.get(process.env.prefix_coupon + '/get-store-coupon-list/' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.removeStoreFromStoreGroup = function (params, data, success, callBackError) {
  this.post(process.env.prefix_outlet + '/outlet-groups/' + params, data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.addStoreIntoStoreGroup = function (params, data, success, callBackError) {
  this.post(process.env.prefix_outlet + '/outlet-groups/' + params, data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.importKML = function (data, configs, success, callBackError) {
  this.post(process.env.prefix_outlet + '/import-kml', data, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
 * @Params : filter + search
 * @Method : get
 * http://127.0.0.1:8000/v1/product-hut-be
 */
axios.getOutletTradezoneList = function (uuid, params, cancel, success, callBackError) {
  this.get( process.env.prefix_outlet + '/tradezones/' + uuid + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}


axios.importSubTradezoneKML = function (data, configs, success, callBackError) {
  this.post( process.env.prefix_outlet + '/subtradezones/import-kml', data, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateSubTradezone = function (data, configs, success, callBackError) {
  this.post(process.env.prefix_outlet + '/subtradezones/edit', data, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getSubTradezoneDetail = function (id, success, callBackError) {
  this.get( process.env.prefix_outlet +'/subtradezones/detail/' + id)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
/**
 * @Params : filter + search
 * @Method : get
 */
axios.getSubTradezoneList = function (id, params, cancel, success, callBackError) {
  this.get( process.env.prefix_outlet + '/tradezone/subtradezones/' + id + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
 * Get table list
 * @Data: params
 * @Method: GET
 */
axios.getTableList = function (params, success, callBackError) {
  this.get(process.env.prefix_outlet + '/tables?' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
 * Get detail table
 * @Data: id
 * @Method: GET
 */
axios.getTableDetail = function (id, success, callBackError) {
  this.get(process.env.prefix_outlet + '/table/' + id).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
 * create table
 * @Data: params
 * @Method: POST
 */
axios.createTable = function (data, success, callBackError) {
  this.post(process.env.prefix_outlet + '/table', data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
 * update table
 * @Data: params
 * @Method: POST
 */
axios.updateTable = function (data, success, callBackError) {
  this.put(process.env.prefix_outlet + '/table/' + data.id, data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
 * @Params : id
 * @Method : Delete tradezone
 */
axios.deleteTradezone = function (id, success, callBackError) {
  this.delete( process.env.prefix_outlet + '/tradezones/delete/' + id ).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
 * @Params : id
 * @Method :  Delete subtradezone
 */
axios.deleteSubTradezone = function (id, success, callBackError) {
  this.delete( process.env.prefix_outlet + '/subtradezones/delete/' + id).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

/**
 * @Params : filter + search
 * @Method : get
 */
axios.getNearbyOutlets = async (params, success, callBackError) => {
  const response = await axios.get( process.env.prefix_outlet + '/tradezones/get-nearby-distances/' + params);
  return response;
}

/**
 * @Params :
 * @Method :  Check overlap tradezone
 */
axios.checkOverlapTradezone = async (data) => {
  const response = await axios.put( process.env.prefix_outlet + '/tradezone/check-coords-overlap', data);
  return response;
}

/**
 * @Params :
 * @Method :  update tradezone tradezone
 */
axios.updateTradezone = async (data) => {
  const response = await axios.put( process.env.prefix_outlet + '/tradezones/draw-polygon', data);
  return response;
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Outlet.js